// skills/alchemy/index.js
// Alchemy skill registration

import { skillRegistry } from '../../core/skillRegistry.js';
import { renderAlchemyUI, updateAlchemyUI, initAlchemyUI, cleanupAlchemyUI } from './alchemyUI.js';

skillRegistry.register('alchemy', {
    id: 'alchemy',
    name: 'Alchemy',
    icon: '?',
    iconImage: 'assets/icons/skill_icons/alchemy.png',
    tabs: [
        { id: 'cleaning', name: 'Cleaning', default: true },
        { id: 'potions', name: 'Potions' }
    ],
    render: (params) => renderAlchemyUI(params),
    update: () => updateAlchemyUI(),
    init: () => initAlchemyUI(),
    cleanup: () => cleanupAlchemyUI()
});
